import type { TextOnCopy } from './type'

// eslint-disable-next-line import/no-mutable-exports
export let onCopy: TextOnCopy

export function setTextOnCopy(fn: TextOnCopy) {
  onCopy = fn
}
